<template>
  <div class="page-container">
    <div class="toolbar">
      <el-button type="primary" @click="openModal()">新建角色</el-button>
    </div>
    <el-table stripe :data="roles" border>
      <el-table-column prop="roleName" label="角色名称" />
      <el-table-column prop="roleCode" label="角色编码" />
      <el-table-column prop="description" label="描述" />
      <el-table-column prop="status" label="状态">
        <template #default="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status === 1 ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button size="small" @click="editRole(scope.row)">编辑</el-button>
          <el-button size="small" @click="assignMenu(scope.row)">分配菜单</el-button>
          <el-button size="small" type="danger" @click="handleDeleteRole(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="角色信息" v-model="dialogVisible" width="500px">
      <el-form :model="formData" label-width="100px">
        <el-form-item label="角色名称" required>
          <el-input v-model="formData.roleName" placeholder="请输入角色名称" />
        </el-form-item>
        <el-form-item label="角色编码" required>
          <el-input v-model="formData.roleCode" placeholder="请输入角色编码" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="formData.description" placeholder="请输入角色描述" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formData.status">
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveRole">确定</el-button>
      </template>
    </el-dialog>

    <el-dialog title="分配菜单" v-model="assignDialogVisible" width="600px">
      <el-tree
        :data="menuTree"
        :props="treeProps"
        show-checkbox
        node-key="id"
        :default-checked-keys="checkedMenuIds"
        ref="menuTreeRef"
      />
      <template #footer>
        <el-button @click="assignDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAssignMenu">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue'
import { ElMessage } from 'element-plus'
import { getRoleList, saveRole, deleteRole, getRoleMenuIds, assignRoleMenus, getMenuList } from '../api'

const roles = ref([])
const menus = ref([])
const dialogVisible = ref(false)
const assignDialogVisible = ref(false)
const menuTreeRef = ref(null)
const currentRoleId = ref(null)
const checkedMenuIds = ref([])

const formData = reactive({
  id: null,
  roleName: '',
  roleCode: '',
  description: '',
  status: 1
})

const treeProps = {
  children: 'children',
  label: 'menuName'
}

const menuTree = computed(() => {
  const tree = []
  const map = new Map()
  menus.value.forEach(menu => {
    map.set(menu.id, { ...menu, children: [] })
  })
  menus.value.forEach(menu => {
    if (menu.parentId !== 0) {
      const parent = map.get(menu.parentId)
      if (parent) {
        parent.children.push({ ...menu })
      }
    }
  })
  map.forEach(menu => {
    if (menu.parentId === 0) {
      tree.push(menu)
    }
  })
  return tree.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
})

onMounted(() => {
  loadRoles()
  loadMenus()
})

const loadRoles = async () => {
  try {
    const res = await getRoleList()
    roles.value = res.data
  } catch (error) {
    ElMessage.error('加载角色失败')
  }
}

const loadMenus = async () => {
  try {
    const res = await getMenuList()
    menus.value = res.data
  } catch (error) {
    ElMessage.error('加载菜单失败')
  }
}

const openModal = () => {
  Object.assign(formData, { id: null, roleName: '', roleCode: '', description: '', status: 1 })
  dialogVisible.value = true
}

const editRole = (row) => {
  Object.assign(formData, row)
  dialogVisible.value = true
}

const handleSaveRole = async () => {
  if (!formData.roleName) {
    ElMessage.warning('请输入角色名称')
    return
  }
  if (!formData.roleCode) {
    ElMessage.warning('请输入角色编码')
    return
  }
  try {
    await saveRole(formData)
    ElMessage.success('保存成功')
    dialogVisible.value = false
    loadRoles()
  } catch (error) {
    ElMessage.error('保存失败')
  }
}

const handleDeleteRole = async (id) => {
  try {
    await deleteRole(id)
    ElMessage.success('删除成功')
    loadRoles()
  } catch (error) {
    ElMessage.error('删除失败')
  }
}

const assignMenu = async (row) => {
  currentRoleId.value = row.id
  assignDialogVisible.value = true
  try {
    const res = await getRoleMenuIds(row.id)
    checkedMenuIds.value = res.data || []
  } catch (error) {
    checkedMenuIds.value = []
  }
}

const handleAssignMenu = async () => {
  if (!currentRoleId.value) return
  const keys = menuTreeRef.value.getCheckedKeys()
  try {
    await assignRoleMenus({ roleId: currentRoleId.value, menuIds: keys })
    ElMessage.success('分配成功')
    assignDialogVisible.value = false
  } catch (error) {
    ElMessage.error('分配失败')
  }
}
</script>